"use client";

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fieldDefinitionKeys } from "@/queries/keys";
import { getFields, type FieldFilters } from "./api";

export function useFields(filters?: FieldFilters) {
  return useQuery({
    queryKey: fieldDefinitionKeys.list((filters ?? {}) as Record<string, unknown>),
    queryFn: () => getFields(filters),
    // Filters ride in the key, so every keystroke is a fresh key. Without this the list
    // unmounts mid-search and the search input loses focus with it.
    placeholderData: keepPreviousData,
  });
}
